// extracted by mini-css-extract-plugin
export default {"overlay":"style_overlay__azAYd","open":"style_open__EC-zU"};